import { User } from '../../modules/common/types/types'
import { Product } from '../../modules/auction/types'
export interface CommonListQuery {
    keyword?: string,
    page?: number,
    size?: number,
    // searchStatusDTO?: StatuteParam,
}

export interface GetCategoryQuery {
    keyword?: string,
    page?: number,
    size?: number,
    isPublic?: number,
    // searchStatusDTO?: StatuteParam,
}

export interface ProductCategory {
    categoryId: number,
    createdBy: string,
    createdDate: number,
    isDelete: number,
    modifiedBy: string,
    modifiedDate: number,
    name: string,
    productCategoryCode: string,
    status: number
}

export interface ProductCategoryList {
    content: ProductCategory[],
    totalElements: number,
}

export interface UploadFileType {
    file: FormData,
    note?: string,
    objectType: number,
    storageType?: string,
}

export interface UploadFileForBidOrderType {
    listFileIds: number[],
    objectId: number,
    objectType: number,
}

export interface UploadFileResponse {
    attachmentId: number,
    contentType: string,
    creatorId: number,
    fileExtention: string,
    fileName: string,
    fileServiceId: number,
    isDelete: number,
    isEncrypt: number,
    note: string,
    objectType: number,
    pdfAlready: number,
    storageType: string,
    updatorId: number,
}

export interface FileByObjectIdAndType {
    objectId: number,
    objectType: number,
    storageType?: string,
}

export interface CreateProduct {
    productName: string,
    description: string,
    startPrice: number,
    productType: number,
    categoryIds: number[];
    sellerId: number,
    status?: number,
    biddingCostPerBid?: number,
    addressHasProperty?: string,
    startPricePercent?: number,
    feeForFailed?: number,
    isStop?: number,
    preCost?: number
}

export interface ProductByParam {
    statuteId: number,
}

export interface StatuteParam {
    auctionMethodId?: number,
    auctionTypeId?: number,
    fromDate?: string,
    isPublic?: number,
    operatorId?: number,
    productName?: string,
    publicProgressAuction?: number,
    status?: number,
    statuteCode?: string,
    toDate?: string,
    type?: number
}

export interface UpdateProduct {
    addressHasProperty: string,
    anotherCost: number,
    biddingCostPerBid: number,
    biddingDownPerTurn?: number,
    description: string,
    endAuctionDate?: number | null,
    minPrice?: number,
    orderNumber: number,
    preCost: number,
    productId: number,
    startAuctionDate?: number | null
}

export interface CreateStatuteParam {
    allowWithdrawPaid: number,
    auctionMethodId: number,
    auctionTypeId: number,
    bidRule: number,
    contractId: number,
    endDate: string,
    endPrePaymentDate: string,
    endRegistrationDate: string,
    incrementInTimePerBid: number,
    note1: string,
    products: UpdateProduct[],
    publicAuction: number,
    startDate: string,
    startPrePaymentDate: string,
    startRegistrationDate: string,
    timePerPriceDown: number,
    timePerProduct: number,
    totalRound: number,
    type: number,
    statuteId?: number,
}

export interface GetStatuteCodeResponse {
    createdDate: number,
    modifiedDate: number
    createdBy: string,
    modifiedBy: string,
    statuteId: number,
    code: string,
    isDeleted: number,
    status: number,
    bidRule: number,
    type: number,
    isPublic: number
}

export interface RegisterAuctionParam {
    productId: number,
    userId: number
}

export interface GetRegisterDetail {
    bidderId: number,
    user: User,
    product: Product,
    status: number,
    registerStatus: number,
    auctionStatus: number,
    preCostStatus: number,
    bidderRegisterHistories: any,
    createdDate: number,
    identityCode: string,
    isActive?: number
}

export interface IntroduceInfoDetail {
    createdDate: number,
    modifiedDate: number,
    createdBy: string,
    modifiedBy: string,
    introduceId: number,
    introduceCode: string,
    content: string,
}

export interface SpecsResponse {
    configGlobalSettingId: number,
    configKey: string,
    configValue: number,
}


export interface GetGoogleToken {
    redirect_uri?: string,
    code: string
}

export interface GoogleTokenResponse {
    accessToken: string,
    email: string
}

export interface NotificationSearch extends CommonListQuery {
    type: string
}

export interface NotificationResponse {
    createdDate: number,
    modifiedDate: number,
    createdBy: string,
    modifiedBy: string,
    id: number,
    userId: number,
    userName: string,
    fullName: string,
    productId: number,
    productName: string,
    productCode: string,
    description: string,
    type: string,
    read: boolean,
    statuteId: number,
    vbAttachmentImages: UploadFileResponse[],
}

export interface NotificationList {
    content: NotificationResponse[],
    totalElements: number,
}

export enum NotificationTypes {
    TAISAN = "tai_san",
    DIENBIEN = "dien_bien",
}

export interface BannerResponseList {
    content: BannerResponse[],
    totalElements: number,
    totalPages: number,
}

export interface BannerResponse {
    id: number,
    createdBy: string,
    createdDate: number,
    createdDateStr: string,
    isDelete: number,
    status: number,
    statusStr: string,
    title: string,
    url: string,
    urlResize: string,
}

export interface LinkResponse {
    createdBy: string,
    createdDate: number,
    id: number,
    isDelete: 0,
    modifiedBy: string,
    modifiedDate: number,
    status: number,
    title: string,
    url: string,
}

